import React, { useState, useEffect } from "react";
import Table from "../../../core/pagination/Newdatatable";
import { Link } from "react-router-dom";
// import dayjs from "dayjs";
import { getApiBaseUrl } from "../Config/Config";
import { Popover, Spin, Tag } from "antd";

const RoleNotifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [notificationsLoading, setNotificationsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [totalRecords, setTotalRecords] = useState(0);

  const handleMarkAsRead = async (record) => {
    try {
      await fetch(`${getApiBaseUrl()}/api/updatenotificationsIsRead`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: record.id }),
      });
      console.log(`Notification ${record.id} marked as read`);
    } catch (error) {
      console.error("Error marking notification as read:", error);
    } finally {
      fetchNotifications();
    }
  };

  const columns = [
    {
      title: "Title",
      dataIndex: "Title",
      key: "Title",
    },
    {
      title: "Message",
      dataIndex: "Message",
      key: "Message",
      sorter: (a, b) => a.Message?.localeCompare(b.Message),
      render: (text) => (
        <Popover
          content={
            <div
              style={{
                maxWidth: "70vw",
                maxHeight: "70vh",
                overflowY: "auto",
                whiteSpace: "normal",
                wordBreak: "break-word",
              }}
            >
              {text}
            </div>
          }
          trigger="click"
          placement="top"
        >
          <div
            className="text-truncate"
            style={{ maxWidth: "35vw", cursor: "pointer" }}
          >
            {text}
          </div>
        </Popover>
      ),
    },
    {
      title: "Status",
      dataIndex: "IsRead",
      key: "IsRead",
      render: (isread) =>
        isread === true ? (
          <Tag color="green">Read</Tag>
        ) : (
          <Tag color="red">Unread</Tag>
        ),
    },
    {
      title: "Date",
      dataIndex: "CreatedAt",
      key: "CreatedAt",
      // render: (text) => dayjs(text).format("DD/MM/YYYY HH:mm"),
      render: (text) => {
        if (!text) return "";
        const d = new Date(text);
        const pad = (n) => String(n).padStart(2, "0");
        return `${pad(d.getUTCDate())}/${pad(
          d.getUTCMonth() + 1,
        )}/${d.getUTCFullYear()} ${pad(d.getUTCHours())}:${pad(
          d.getUTCMinutes(),
        )}`;
      },
    },

    {
      title: "Actions",
      dataIndex: "actions",
      align: "center",
      render: (_, record) => (
        <div>
          <button
            className="btn btn-sm btn-success me-2"
            title="Mark as Read"
            disabled={record?.IsRead}
            onClick={() => handleMarkAsRead(record)}
          >
            <i className="fas fa-check"></i>
          </button>
          {/* <button
            className="btn btn-sm btn-danger"
            title="Send to Delete"
            // onClick={() => handleDelete(record)}
          >
            <i className="fas fa-times"></i>
          </button> */}
        </div>
      ),
    },
  ];

  const fetchNotifications = async (page = 1, limit = 100) => {
    const user = JSON.parse(sessionStorage.getItem("user"));

    setNotificationsLoading(true);
    try {
      const response = await fetch(
        `${getApiBaseUrl()}/api/getnotificationsToUser?UserID=${user?.UserID}&pageNumber=${page}&recordslimit=${limit}`,
      );
      const result = await response.json();
      const list = result?.ResultData || [];
      if (result?.Status) {
        setNotifications(list || []);
      } else {
        setNotifications([]);
      }
      if (list?.length > 0) {
        setTotalRecords(list[0]?.TotalCount);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
      setNotifications([]);
    } finally {
      setNotificationsLoading(false);
    }
  };

  useEffect(() => {
    fetchNotifications(currentPage, pageSize);
  }, [currentPage, pageSize]);

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/assetmgt/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item " aria-current="page">
                    Notifications
                  </h4>
                </ol>
              </nav>
              <h6>Manage Your notifications</h6>
            </div>
          </div>
        </div>
        <div className="card table-list-card">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <div className="search-set mt-4"></div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              {notificationsLoading ? (
                <div className="text-center my-4">
                  <Spin size="large" />
                  <p>Loading data...</p>
                </div>
              ) : notifications.length > 0 ? (
                <Table
                  dataSource={notifications}
                  columns={columns}
                  currentPage={currentPage}
                  pageSize={pageSize}
                  totalRecords={totalRecords}
                  onPageChange={(page, size) => {
                    setCurrentPage(page);
                    setPageSize(size);
                  }}
                />
              ) : (
                <p className="text-center my-4">No data available</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoleNotifications;
